import { z } from "zod";
import { IdType } from "./base.validator";

export const createdRole = z.object({
	id: IdType,
	title: z.string(),
	description: z.string(),
});
export type CreatedRoleDto = z.infer<typeof createdRole>;
